import { Bell, Diamond, Menu, Search, UserRound, X } from 'lucide-react';

export type NavKey = 'home' | 'browse' | 'my-list' | 'continue';

interface HeaderProps {
  activeNav: NavKey;
  diamondBalance: number;
  mobileMenuOpen: boolean;
  onNavigate: (key: NavKey) => void;
  onSearch: () => void;
  onOpenShop: () => void;
  onOpenTools: () => void;
  onToggleMobileMenu: () => void;
}

const navItems: Array<{ key: NavKey; label: string }> = [
  { key: 'home', label: 'Home' },
  { key: 'browse', label: 'Browse' },
  { key: 'my-list', label: 'My List' },
  { key: 'continue', label: 'Continue Watching' }
];

export function Header({
  activeNav,
  diamondBalance,
  mobileMenuOpen,
  onNavigate,
  onSearch,
  onOpenShop,
  onOpenTools,
  onToggleMobileMenu
}: HeaderProps) {
  return (
    <header className="app-header">
      <button className="brand-button" onClick={() => onNavigate('home')} aria-label="Go to home">
        <img src="/images/FallenCathedral_Logo.png" alt="Fallen Cathedral" className="brand-logo" />
      </button>

      <nav className="desktop-nav" aria-label="Primary navigation">
        {navItems.map((item) => (
          <button
            key={item.key}
            className={activeNav === item.key ? 'nav-link active' : 'nav-link'}
            onClick={() => onNavigate(item.key)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <div className="header-actions">
        <button className="diamond-pill" onClick={onOpenShop} aria-label={`Open diamond shop. Balance ${diamondBalance}`}>
          <Diamond size={18} aria-hidden="true" />
          <strong>{diamondBalance}</strong>
          <span aria-hidden="true">+</span>
        </button>
        <button className="icon-button" onClick={onSearch} aria-label="Search">
          <Search size={24} />
        </button>
        <button className="icon-button header-bell" aria-label="Notifications">
          <Bell size={23} />
          <span className="notification-dot" />
        </button>
        <button className="avatar-button" onClick={onOpenTools} aria-label="Open demo controls">
          <UserRound size={20} />
        </button>
        <button className="icon-button mobile-menu-button" onClick={onToggleMobileMenu} aria-label="Toggle menu">
          {mobileMenuOpen ? <X size={25} /> : <Menu size={25} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <nav className="mobile-nav" aria-label="Mobile navigation">
          {navItems.map((item) => (
            <button
              key={item.key}
              className={activeNav === item.key ? 'nav-link active' : 'nav-link'}
              onClick={() => onNavigate(item.key)}
            >
              {item.label}
            </button>
          ))}
          <button className="nav-link" onClick={onOpenTools}>Demo controls</button>
        </nav>
      )}
    </header>
  );
}
